import { Box, Button, Grid, Typography, Radio, FormControlLabel,DialogActions, RadioGroup, Dialog, DialogContent, DialogTitle, useTheme, useMediaQuery } from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./PostRequirement.module.css";
import {customTextColor} from "../../utils/const";
import PostRequirementCard from "../../components/common/PostRequiredmentCard";
import profile_image from "../../assets/images/signature_example.jpg";
import { useState } from "react";

const PostRquirementViewView = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    // <RootComponents>
      <Box className={styles.post_required_view_structure}>
        <Typography style={{ color: customTextColor }}>
          POST REQUIREMENT - VIEWED
        </Typography>

        <Grid container>
          <Grid item xs={6} sm={6} md={3} lg={3} sx={{ padding: "0 10px 20px" }}>
            <PostRequirementCard
              count="200"
              text="Posting1"
              bgColor="#f2f2f2"
              color="#3f475a"
              padding="10px 10px 10px 30px"
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} sx={{ padding: "0 10px 20px" }}>
            <PostRequirementCard
              count="75"
              text="Posting2"
              bgColor="#f2f2f2"
              color="#3f475a"
              padding="10px 10px 10px 30px"
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} sx={{ padding: "0 10px 20px" }}>
            <PostRequirementCard
              count="15"
              text="Posting3"
              bgColor="#f2f2f2"
              color="#3f475a"
              padding="10px 10px 10px 30px"
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3} lg={3} sx={{ padding: "0 10px 20px" }}>
            <PostRequirementCard
              count="10"
              text="Posting4"
              bgColor="#f2f2f2"
              color="#3f475a"
              padding="10px 10px 10px 30px"
            />
          </Grid>
        </Grid>
        <Box className={styles.job_criteria_details}>
          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              Job Title : <b>Lead Java Developer</b>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              Total Experience : <b>12 + years</b>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              Job Location :<b>Kolkata India</b>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              Job Type : <b>Full Time</b>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              Required Visa : <b>Unknown</b>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              Rate : <b>5000</b>
            </Grid>
          </Grid>
        </Box>
        <Box className={styles.required_mandtory_sckilled_box}>
          <Typography>Required & Mandatory Skills</Typography>
          <span>
            Peter always saw the world in black and white. There were two choices
            for every situation and you had to choose one of them. It was
            therefore terribly uncomfortable for him to spend time with Ashley.
            She saw the world in shades of gray with hundreds of choices to choose
            from in every situation.
          </span>
        </Box>
        <Box className={styles.required_mandtory_sckilled_box}>
          <Typography>Recruiter Signature</Typography>
          <img
            src={profile_image}
            alt=""
            width="200px"
            height="50px"
            style={{ textAlign: "center" }}
          />
        </Box>
        <Box className={styles.post_required_view_btns}>
          <Button sx={{ backgroundColor: '#2C4DAB !important', padding: '9px 50px !important' }}>Edit Post</Button>
          <Button sx={{ backgroundColor: '#CA2020 !important' }} onClick={handleClickOpen}>
              Changes Status
            </Button>
        </Box>

        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title" sx={{textAlign:'center'}}>
            {"Job Status "}
          </DialogTitle>
          <DialogContent>
            <Box className={styles.found_candidate_list} sx={{ color: customTextColor, padding: '0 60px' }} >
              <Box>
               
                <RadioGroup>
                  <FormControlLabel
                    value="internalSubmission"
                    control={<Radio />}
                    label={
                      <Typography>
                        <span><b>1st Position Hold</b></span>
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="credit"
                    control={<Radio />}
                    label={
                      <Typography>
                        <span><b>2nd Position Closed</b></span>
                      </Typography>
                    }
                  />
                </RadioGroup>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions >
            <Button onClick={handleClose} sx={{
              backgroundColor: 'green', padding: '5px 10px', display: 'block', margin: '0 auto', color: 'white', marginBottom:'10px', '&:hover':{
                backgroundColor: 'darkgreen',
              },
            }}>
              Update
            </Button>

          </DialogActions>
        </Dialog>
      </Box>
    // </RootComponents>
  );
};

export default PostRquirementViewView;
